var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inTab',{attrs:{"tabs":_vm.Tabs,"headerStyla":"margin-top:80px;"}},[_c('inComments',{attrs:{"ProductSku":_vm.ProductSku}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }